import React from "react";

export const RemoveNights: React.FunctionComponent = (props) => {
  return <>Remove Nights</>;
};
